import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IContentNotesSaveRequest {
	htmlContent: string;
	accountId: string;
	businessName: string;
	industry?: string;
}

export interface IContentNotesSaveResponse {
	noteId?: string;
	clickUpEmailSent?: boolean;
}

export function useAdminContentNotesSaveMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IContentNotesSaveRequest) => {
			return userSession.webServiceHelper.callAsync<IContentNotesSaveResponse>(
				'admin/zoom/transcripts/content-notes/save',
				'POST',
				request
			);
		},
	});
}
